import { HTTPClient } from '../utils/request'

export default {
  getAnalysis: ({ query = `` }) => HTTPClient.get(`/guep${query}`),
  getReturns: ({ query = `` }) => HTTPClient.get(`/gr${query}`),
  get: ({ query = `` }) => HTTPClient.get(`/gr${query}`),
  evaluation: ({ params, payload }) =>
    HTTPClient.post(`/gr/${params._id}`, payload),
  retification: ({ params, payload }) =>
    HTTPClient.post(`/gr/${params._id}/retification`, payload),
  research: ({ params, query }) =>
    HTTPClient.post(
      `/drivers/${params._id}/applyGR${
      // eslint-disable-next-line no-undef
      process.env.NODE_ENV === `production` ? `` : query
      }`
    ),
  query: ({ params, query }) =>
    HTTPClient.post(
      `/gr/${params._id}/consultGR${
      // eslint-disable-next-line no-undef
      process.env.NODE_ENV === `production` ? `` : query
      }`
    ),
  reports: () => HTTPClient.get(`/guep/reports`),
  grResearch: ({ params }) =>
    HTTPClient.post(
      `/drivers/${params._id}/gr?status=ACORDO&gr=${params.gr}&costCenter=${params.costCenter}`
    ),
  horusResearch: ({ params }) =>
    HTTPClient.post(`/gr/${params._id}/horus/${params.state}`, {
      costCenter: params.costCenter
    }),
  skymarkResearch: ({ params }) =>
    HTTPClient.post(`/gr/${params._id}/skymark`, {
      costCenter: params.costCenter
    }),
  teleriscoSearch: ({ params }) =>
    HTTPClient.post(`telerisco/pesquisa/${params._id}`, {
      costCenter: params.costCenter || ''
    }),
  otnetSearch: ({ params }) =>
    HTTPClient.post(`otnet/search`, {
      driver_id: params._id,
      costCenter: params.costCenter || ''
    }),
  opentechSearch: ({ params }) =>
    HTTPClient.post(`openTech/search/${params._id}`, {
      costCenter: params.costCenter || '',
      rdo: params.rdo
    }),
  opentechRegister: ({ params }) => HTTPClient.post(`openTech/register/${params._id}`),
  opentechConsult: ({ params }) =>
    HTTPClient.post(`openTech/consult/${params._id}`, {
      costCenter: params.costCenter || '',
      research: params.research
    }),
  buonnyRegister: ({ params, payload }) =>
    HTTPClient.post(`/gr/buonny/register/${params._id}`, payload),
  buonnyQuery: ({ params, payload }) =>
    HTTPClient.post(`/gr/buonny/query/${params._id}`, payload)
}
